export const getFullScreenChartSubTitle = (
  heatNo: string | number,
  heatName: string,
) => `Heat: #${heatNo} (${heatName})`;

//INFO: Fatih,  Backend sends current heat and repair heat together. [repairHeat,currentHeat] or just [currentHeat]
// So, we ignored last item of the array.

export const getRepairList = (repairs: number[]) => {
  return repairs && repairs.length > 0 ? repairs.slice(0, -1) : [];
};
